import { inject, injectable } from 'inversify';
import Debug from 'debug';
import { TrackingService2, TrackingService2Symbol, createQuery } from '@/app/tracking/api';
import { BadgeStoreModule, BadgeStoreModuleSymbol } from '../../store';
import * as BadgeTrackingApi from '../../tracking/api'
import { BadgesEarnedNotifier } from './badges-earned-notifier';
import { CancelToken } from '@/app/shared/utils/cancel-token'

const debug = Debug('query-badges-tracking-state-command');

@injectable()
export class QueryBadgesTrackingStateCommand {

  constructor(
    @inject(TrackingService2Symbol)
    private trackingService: TrackingService2,
    @inject(BadgeStoreModuleSymbol)
    private store: BadgeStoreModule,
    @inject(BadgesEarnedNotifier)
    private badgesEarnedNotifier: BadgesEarnedNotifier) {
  }

  public async execute(cancelToken: CancelToken) {

    debug(`querying badges' tracking state`);

    this.store.startRemoteQuerying();

    const query = createQuery<BadgeTrackingApi.QueryBadgeStatesTrackingQuery>('query-badge-states', {})
    const result = await this.trackingService.query(query, cancelToken)

    
    const states: BadgeTrackingApi.BadgeState[] = result.badges.map((x) => ({ ...x }));
    debug(`badges' remote tracking state queried: %j`, states);
    this.store.finishRemoteQuerying(states);

    // notify badges which earned locally (diff from remote)
    const newBadges = this.store.locallyEarnedBadges.filter((item) => !states.find((y) => y.id === item.id));
    debug(`current local badges: %j`, this.store.locallyEarnedBadges);
    debug(`newly locally earned badges: %j`, newBadges);
    if (newBadges.length > 0) {
      this.badgesEarnedNotifier.notify(newBadges);
    }
  }

  private setTimeout(ms: number): Promise<void> {
    return new Promise((resolve) => {
      setTimeout(() => { resolve(); }, ms);
    });
  }
}
